import Swiper, { Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderPartners(containerId) {
    const containerSlider = $(containerId);

    const swiperPartners = new Swiper(containerId + ' .swiper-no-padding ', {
        modules: [Navigation, Pagination, Lazy, Scrollbar],

        slidesPerView: 3,
        spaceBetween: 22,
        allowTouchMove: false,

        breakpoints: {
            0: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                allowTouchMove: true,
            },
            //sm
            640: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                allowTouchMove: true,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });

    swiperPartners.on('slideChange', function () {
        // containerSlider.find('.slider-current-page').html((this.realIndex + 1).toString().padStart(2, '0'));
        containerSlider.find('.slider-current-page').html('01');
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$(function () {
    $('.slider-procampo-parcerias').each(function () {
        initializeSliderPartners('#' + $(this).attr('id'));
    });
});
